// extracted by mini-css-extract-plugin
module.exports = {"threedotsMenu":"style_threedotsMenu__5lxIY","menu":"style_menu__21XX7","Dropdown":"style_Dropdown__CrKOm","threeDotsIcon":"style_threeDotsIcon__1YVkJ"};